import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL

/* const USER_API_BASE_URL = "http://localhost:8080/api/v1/users"; */
const USER_API_BASE_URL = 'http://localhost:4000/users'
const SENSOR_API_BASE_URL = "http://localhost:8080/api/v1/sensors";
const PDF_API_BASE_URL = "http://localhost:8080/api/v1/pdfreports";
const FLOW_API_BASE_URL = "http://localhost:8080/api/v1/flowdetails?flowDetails";

const Info_API_BASE_URL = `${BASE_URL}/workflow_engine/api/v1/createwarning`
const FLOWDetails_API_BASE_URL = `${BASE_URL}/workflow_engine/api/v1/getflowvalue?`

const FLOWDetailsByID_API_BASE_URL = "http://localhost:8080/api/v1/getflow";

export const getUsers = () => {
    return axios.get(USER_API_BASE_URL)
};

export const getUserById = (userId: any) => {
    return axios.get(USER_API_BASE_URL + '/' + userId);
}


export const getSensors = () => {
    return axios.get(SENSOR_API_BASE_URL)
};

export const getSensorById = (sensorId: any) => {
    return axios.get(SENSOR_API_BASE_URL + '/' + sensorId);
}


export const getPdfReport = () => {
    return axios.get(PDF_API_BASE_URL)
};

export const getPdfReportById = (pdfId: any) => {
    return axios.get(PDF_API_BASE_URL + '/' + pdfId);
}

export const AddFlowDetails = (flowDetails: string) => {
    return axios.post(FLOW_API_BASE_URL+ '=' + flowDetails)
}


export const AddInfomationDetais = (warningid: string, username: string, departments: string, warningtype: string, hazardtype: string, workflowType: string, workflowTriggerType: string, localization: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.error("No access token found in localStorage");
      return Promise.reject("Unauthorized: No token found");
    }
  
    const url = `${Info_API_BASE_URL}?warningid=${warningid}&username=${username}&departments=${departments}&warningtype=${warningtype}&hazardtype=${hazardtype}&workflowType=${workflowType}&workflowTriggerType=${workflowTriggerType}&localization=${localization}`;
  
    return axios.post(url, {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  };


  export const getFlowFileDetails = (userid: string) => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      console.error("No access token found in localStorage");
      return Promise.reject("Unauthorized: No token found");
    }
  
    const url = `${FLOWDetails_API_BASE_URL}warningid=${userid}`;
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

export const getFlowFileDetailsByID = (userid: string) => {
  const token = localStorage.getItem("access_token");
  if (!token) {
    console.error("No access token found in localStorage");
    return Promise.reject("Unauthorized: No token found");
  }

  const url = `${FLOWDetails_API_BASE_URL}warningid=${userid}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};